/* eslint-disable default-param-last */
/**
 * @description Ações relacionadas a definição do state da aplicação
 * @author Bene Lemuel Dantas Gondim
 * @file sessionReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'
import * as actionTypes from 'actions'

// Estado inicial da sessão no redux
const initialState = {
  loggedIn: false,
  erroLogin: false,
  cpfSenhaIncorretos: false,
  tokenExpirado: false,
  senhaRedefinida: false,
  solicitar_redefinir_senha_sucesso: false,
  token: localStorage.getItem('@sigep/token') || '',
  usuario: null,
}

// Trata as possibilidades de login, se sucesso, define o estado do redux armazenando as informações do usuário
const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SESSION_LOGIN_SUCESSO: {
      return {
        ...state,
        loggedIn: true,
        token: localStorage.getItem('@sigep/token') || action.token,
        usuario: action.usuario,
      }
    }

    case types.RENEW_SESSION_SUCESSO: {
      return {
        ...state,
        token: localStorage.getItem('@sigep/token') || action.token,
        usuario: action.usuario,
      }
    }

    case actionTypes.SESSION_LOGIN_ERRO_LOGIN_ERROR: {
      return {
        ...state,
        erroLogin: true,
      }
    }

    case actionTypes.SESSION_LOGIN_CPF_SENHA_INCORRETOS_ERROR: {
      return {
        ...state,
        cpfSenhaIncorretos: true,
      }
    }

    case actionTypes.SESSION_LOGOUT_SUCESSO: {
      return {
        ...initialState,
      }
    }

    case types.SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO: {
      return {
        ...initialState,
        tokenExpirado: true,
      }
    }

    case actionTypes.REDEFINIR_SENHA_SUCESSO: {
      return {
        ...initialState,
        senhaRedefinida: true,
      }
    }

    case types.SOLICITAR_REDEFINIR_SENHA_SUCESSO: {
      return {
        ...state,
        solicitar_redefinir_senha_sucesso: true,
      }
    }

    default: {
      return state
    }
  }
}

export default sessionReducer
